import { useState, useEffect, useRef } from "react";
import "./MovePage.css";

function MovePage() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [trailPositions, setTrailPositions] = useState([]);
  const [isInSidebar, setIsInSidebar] = useState(false);
  const movePageRef = useRef(null);

  useEffect(() => {
    // 处理鼠标移动事件
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;

      // 判断鼠标是否在侧边栏区域内
      // 获取MovePage容器的位置信息
      const movePageRect = movePageRef.current.getBoundingClientRect();

      // 判断点击位置是否在MovePage容器内
      const isInsideMainContent =
        clientX >= movePageRect.left &&
        clientX <= movePageRect.right &&
        clientY >= movePageRect.top &&
        clientY <= movePageRect.bottom;

      const wasInSidebar = isInSidebar;
      setIsInSidebar(!isInsideMainContent);

      if (!isInsideMainContent) {
        // 如果在侧边栏区域，清空拖影数组
        if (!wasInSidebar) {
          setTrailPositions([]);
        }
        return; // 不更新圆圈位置
      }

      setMousePosition({ x: clientX, y: clientY });

      // 更新拖影位置数组
      setTrailPositions((prevPositions) => {
        const newPositions = [...prevPositions, { x: clientX, y: clientY }];
        // 只保留最近的5个位置
        if (newPositions.length > 5) {
          return newPositions.slice(newPositions.length - 5);
        }
        return newPositions;
      });
    };

    // 添加鼠标移动事件监听
    window.addEventListener("mousemove", handleMouseMove);

    // 清理函数
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isInSidebar]); // 添加isInSidebar作为依赖项

  return (
    <div className="move-page" ref={movePageRef}>
      {/* 主要鼠标跟随圈 - 仅当不在侧边栏时显示 */}
      {!isInSidebar && (
        <>
          <div
            className="mouse-follower"
            style={{
              left: `${mousePosition.x}px`,
              top: `${mousePosition.y}px`,
            }}
          />

          {/* 拖影效果，渲染5个延迟的圈 */}
          {trailPositions.map((position, index) => (
            <div
              key={index}
              className="trail-circle"
              style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
                opacity: 0.8 - index * 0.15, // 越早的位置透明度越低
              }}
            />
          ))}
        </>
      )}
    </div>
  );
}

export default MovePage;
